import { createApp } from "vue";
import { createPinia } from "pinia";
import ElementPlus from "element-plus";
import ko from "element-plus/es/locale/lang/ko";
import "element-plus/dist/index.css";
import "@/shared/styles/index.scss";
import App from "./App.vue";
import router from "./router";

const app = createApp(App);

app.use(createPinia());
app.use(router);
// 페이지네이션의 "Total / page / Go to", 날짜 선택기 요일 등 내장 문구가 영문으로 나오고 있었다.
app.use(ElementPlus, { locale: ko });

app.mount("#app");
